import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './style.css';

const $root = document.querySelector('#root');

if ($root) {
  ReactDOM.render(<App />, $root);
}